import { Input } from "common/InputForm";
import useButtonLoader from "hooks/useButtonLoader";
import { CustomButton } from "components/form";
import React, { useEffect, useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { forgetApi, verifyForgotPasswordApi } from "services/auth";
import { toastMessage } from "utils/toastMessage";
import { auth } from "validation/schema/auth";
import { ValidateInput } from "validation";

const VerifyPassword = ({ data, setData, setSteps, setUserId }) => {
  const [buttonLoader, setButtonLoader] = useButtonLoader("Reset Password");
  const [error, setError] = useState("");
  const [seconds, setSeconds] = useState(30);

  // Input Validtion
  const validation = () => {
    const { errors, status } = ValidateInput(
      data,
      "verifyPasswordSchema",
      auth,
      null
    );
    setError(errors);
    return status;
  };

  useEffect(() => {
    if (seconds < 30) {
      return;
    }

    const intervalId = setInterval(() => {
      setSeconds((prevTime) => {
        if (prevTime === 0) {
          clearInterval(intervalId);
          return 0;
        }

        return prevTime - 1;
      });
    }, 1000);
  }, [seconds]);

  // on change handler
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  // Forget password handler
  const forgetPasswordHandler = async (e) => {
    e.preventDefault();
    if (validation()) {
      try {
        setButtonLoader(true);
        const { data: responseData, status } = await verifyForgotPasswordApi(data);
        if (status === 200) {
          console.log("---------", responseData?.data.userId);
          setUserId(responseData?.data.userId)
          toastMessage(responseData?.message, "success", "forgotPassword");
          setData({});
          setSteps(7);
        }
      } catch (e) {
        console.log("error", e);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  // Forget password handler
  const resendCodeHandler = async (e) => {
    e.preventDefault();
    try {
      setButtonLoader(true);
      const { data: responseData, status } = await forgetApi(data);
      if (status === 200) {
        toastMessage("Code has been sent", "success", "forgotPassword");
        setSeconds(30);
      }
    } catch (e) {
      console.log("error", e);
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <>
      <div className="forgot_password">
        <div className="back_button">
          <button
            type="button"
            onClick={() => {
              setSteps(1);
              setData({});
            }}
          >
            <IoIosArrowBack /> Back to login
          </button>
        </div>

        <div className="form_title">
          <h2>Forgot Password?</h2>
          <p>
            No worries, we've got you covered! Enter your email address below
            and we'll send you a otp to reset your password.
          </p>
        </div>
        <div className="form_field">
          <Input
            label="Email*"
            placeholder="Enter Email"
            name="email"
            maxLength={25}
            value={data.email}
            onChange={onChangeHandler}
            disabled
            error={error?.email}
            extraError={error?.emailErr}
          />
          <label style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
            Didn't received the code?
            {
              !seconds
                ?
                <b style={{ cursor: "pointer", marginLeft: "5px" }} onClick={resendCodeHandler}>Resend Code</b>
                :
                <b style={{ marginLeft: "5px" }}>{seconds}</b>
                
            }
          </label>
        </div>
        <div className="form_field">
          <Input
            label="OTP*"
            placeholder="Enter otp"
            name="otp"
            maxLength={25}
            value={data.otp}
            onChange={onChangeHandler}
            error={error?.otp}
            extraError={error?.otp}
          />
        </div>
        <div className="button_wrap button_right">
          <CustomButton
            type="submit"
            className="button w-100"
            onClick={forgetPasswordHandler}
            ref={buttonLoader}
          >
            Reset Password
          </CustomButton>
        </div>
      </div>
    </>
  );
};

export default VerifyPassword;
